import { Dropdown } from '@lego/klik-ui';
import type { ComponentProps } from 'react';
import type { ApplicationVersionListResponse } from '@/hooks/application_version';

type ApplicationVersionResponse = ApplicationVersionListResponse['applicationVersions'][number];

type Props = {
  versions: ApplicationVersionResponse[];
  isDisabled?: boolean;
  onChange: (value: number | null) => void;
  selectedVersionId: number | null;
  width?: number | string;
};

const formatVersionLabel = (version: ApplicationVersionResponse) =>
  version.tag ? `Version ${version.version} (${version.tag})` : `Version ${version.version}`;

export const StableVersionSelect = ({
  versions,
  isDisabled = false,
  onChange,
  selectedVersionId,
  width,
}: Props) => {
  const dropdownOptions = [
    <Dropdown.Option key="none" value="">
      None
    </Dropdown.Option>,
    ...versions.map((version) => (
      <Dropdown.Option key={version.id} value={String(version.id)}>
        {formatVersionLabel(version)}
      </Dropdown.Option>
    )),
  ] as ComponentProps<typeof Dropdown>['children'];

  return (
    <Dropdown
      isDisabled={isDisabled || versions.length === 0}
      onChange={(value: string) => {
        onChange(value ? Number(value) : null);
      }}
      placeholder={versions.length === 0 ? 'No versions available' : 'Select stable version'}
      size="sm"
      value={selectedVersionId ? [String(selectedVersionId)] : []}
      width={width}
    >
      {dropdownOptions}
    </Dropdown>
  );
};
